import { ListChecks, ScanFace, UserCheck, ShieldAlert, Building2, Smartphone, Scale, Radar, Box } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { NodeProps } from '@xyflow/react'
import type { StepName } from '../../types'
import { NodeShell } from './nodeTypes'
import type { FlowNode } from './nodeTypes'

const STEP_STYLE: Record<StepName, { icon: LucideIcon; color: string }> = {
  MATCHLIST: { icon: ListChecks, color: '#a78bfa' },       // violet
  IDV: { icon: ScanFace, color: '#818cf8' },               // indigo
  KYC: { icon: UserCheck, color: '#38bdf8' },              // sky
  AML: { icon: ShieldAlert, color: '#fb7185' },            // rose
  KYB: { icon: Building2, color: '#2dd4bf' },              // teal
  FRAUD: { icon: Smartphone, color: '#fb923c' },           // orange
  DECISION: { icon: Scale, color: '#fbbf24' },             // amber
  TOGGLEMONITORING: { icon: Radar, color: '#34d399' },     // emerald
}

const FALLBACK_STYLE = { icon: Box, color: '#94a3b8' }

export function StepNode({ data, selected }: NodeProps<FlowNode>) {
  // Fall back gracefully for any step name not in STEP_STYLE (defensive against
  // future/unknown step types in imported workflows).
  const style = (data.stepName && STEP_STYLE[data.stepName]) || FALLBACK_STYLE
  return (
    <NodeShell
      icon={style.icon}
      label={data.label}
      sublabel={data.stepName}
      accentColor={style.color}
      selected={selected}
    />
  )
}
